"use strict";
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
var headers = document.querySelectorAll("thead th");
var currentColumn = null;
var isAsc = true;
headers.forEach(function(th, index) {
    th.addEventListener("click", function() {
        if (currentColumn === index) isAsc = !isAsc;
        else {
            isAsc = true;
            currentColumn = index;
        }
        sortByColumn(index, isAsc);
    });
});
var table = document.querySelector("table");
var tbody = table.querySelector("tbody");
function sortByColumn(colIndex, asc) {
    var _tbody;
    var rowsArray = Array.from(tbody.rows);
    rowsArray.sort(function(a, b) {
        var contentA = a.cells[colIndex].textContent;
        var contentB = b.cells[colIndex].textContent;
        var numA = parseFloat(contentA.replace(/[$,]/g, ""));
        var numB = parseFloat(contentB.replace(/[$,]/g, ""));
        var comparison = 0;
        if (!isNaN(numA) && !isNaN(numB)) comparison = numA - numB;
        else comparison = contentA.localeCompare(contentB);
        return asc ? comparison : -comparison;
    });
    (_tbody = tbody).append.apply(_tbody, _to_consumable_array(rowsArray));
}
tbody.addEventListener("click", function(e) {
    var targetRow = e.target.closest("tr");
    if (!targetRow || !tbody.contains(targetRow)) return;
    var activeRow = tbody.querySelector(".active");
    if (activeRow) activeRow.classList.remove("active");
    targetRow.classList.add("active");
});
var form = document.createElement("form");
form.classList.add("new-employee-form");
form.innerHTML = '\n  <label>Name: <input name="name" type="text" data-qa="name" required></label>\n  <label>Position: <input name="position" type="text" data-qa="position"></label>\n  <label>Office:\n    <select name="office" data-qa="office" required>\n      <option value="Tokyo">Tokyo</option>\n      <option value="Singapore">Singapore</option>\n      <option value="London">London</option>\n      <option value="New York">New York</option>\n      <option value="Edinburgh">Edinburgh</option>\n      <option value="San Francisco">San Francisco</option>\n    </select>\n  </label>\n  <label>Age: <input name="age" type="number" data-qa="age" required></label>\n  <label>Salary: <input name="salary" type="number" data-qa="salary" required></label>\n  <button type="submit">Save to table</button>\n';
document.body.appendChild(form);
form.addEventListener("submit", function(e) {
    e.preventDefault();
    var nameValue = form.elements.name.value.trim();
    var ageValue = form.elements.age.value.trim();
    var positionValue = form.elements.position.value.trim();
    var officeValue = form.elements.office.value;
    var salaryValue = form.elements.salary.value;
    if (!nameValue || !ageValue || !positionValue || !salaryValue) {
        showNotification("\u0412\u0441\u0456 \u043F\u043E\u043B\u044F \u043C\u0430\u044E\u0442\u044C \u0431\u0443\u0442\u0438 \u0437\u0430\u043F\u043E\u0432\u043D\u0435\u043D\u0456", true);
        return;
    }
    if (nameValue.length < 4) {
        showNotification("\u0406\u043C'\u044F \u0437\u0430\u043D\u0430\u0434\u0442\u043E \u043A\u043E\u0440\u043E\u0442\u043A\u0435", true);
        return;
    }
    var ageNum = Number(ageValue);
    if (ageNum < 18 || ageNum > 90) {
        showNotification("\u041F\u043E\u043C\u0438\u043B\u043A\u0430: \u0432\u0456\u043A \u043C\u0430\u0454 \u0431\u0443\u0442\u0438 \u0432\u0456\u0434 18 \u0434\u043E 90", true);
        return;
    }
    if (positionValue.length < 4) {
        showNotification("\u041F\u043E\u0441\u0430\u0434\u0430 \u043D\u0435 \u0432\u0430\u043B\u0456\u0434\u043D\u0430", true);
        return;
    }
    var salaryNum = Number(salaryValue);
    var formattedSalary = "$" + salaryNum.toLocaleString("en-US");
    var newRow = document.createElement("tr");
    newRow.innerHTML = "\n    <td>".concat(nameValue, "</td>\n    <td>").concat(positionValue, "</td>\n    <td>").concat(officeValue, "</td>\n    <td>").concat(ageValue, "</td>\n    <td>").concat(formattedSalary, "</td>\n  ");
    tbody.appendChild(newRow);
    showNotification("\u041F\u0440\u0430\u0446\u0456\u0432\u043D\u0438\u043A\u0430 \u0434\u043E\u0434\u0430\u043D\u043E!", false);
    form.reset();
});
function showNotification(message, isError) {
    var notification = document.createElement("div");
    notification.setAttribute("data-qa", "notification");
    notification.className = isError ? "error" : "success";
    notification.textContent = message;
    document.body.appendChild(notification);
    setTimeout(function() {
        return notification.remove();
    }, 4000);
}

//# sourceMappingURL=index.74ad7fa9.js.map
